<ng-container [ngSwitch]="status">
  <mat-chip-list>
    <mat-chip
      outlined
      size="sm"
      class="down-appliance-chip-stats"
      *ngSwitchCase="APPLIANCE_STATUS.Down"
    >
      <div class="down-appliance-chip-label">
        <span>{{ 'common.down' | t }}</span>
      </div>
    </mat-chip>
    <mat-chip
      outlined
      size="sm"
      class="up-appliance-chip-stats"
      *ngSwitchCase="APPLIANCE_STATUS.Up"
      [label]="'common.up' | t"
    >
      <div class="up-appliance-chip-label">
        <span>{{ 'common.up' | t }}</span>
      </div>
    </mat-chip>
    <mat-chip
      outlined
      size="sm"
      class="down-appliance-chip-stats"
      *ngSwitchCase="APPLIANCE_STATUS.Error"
    >
      <div class="down-appliance-chip-label">
        <span>{{ 'common.error' | t }}</span>
      </div>
    </mat-chip>
    <mat-chip
      outlined
      size="sm"
      class="pending-appliance-chip-stats"
      *ngSwitchCase="APPLIANCE_STATUS.Pending"
    >
      <div class="pending-appliance-chip-label">
        <span>{{ 'common.pending' | t }}</span>
      </div>
    </mat-chip>
  </mat-chip-list>
</ng-container>
